import Vue from 'vue';

export default {
  state: {
    fund: {},
  },
  mutations: {
    updateManager(state, { id, data }) {
      // 变更状态
      state.fund[id] = data;
    },
  },
  actions: {
    updateManager({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('FundApi.getFundMNMangerList', id)
          .then((json) => {
            commit('updateManager', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
  },
  getters: {},
};
